import { Storage } from '../../../src/components/storage';
import Shared from '../../../src/components/shared';

import { emptyOpenmoticsApi as api, setApiConfig } from '@openmotics/react-sdk/api';


setApiConfig(Shared.settings.api_root, Storage.getItem('token'));

export const emptyOpenmoticsApi = api;
